export default {
  path: "/",
  name: "Setup",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "/",
      name: "General",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "",
          // component: () => import("@/views/setup/General/Index"),
        },
        {
          path: "/setup/address-master",
          name: "Address Master",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              component: () =>
                import("@/views/setup/General/AddressMaster/AddressMaster.vue"),
            },
            {
              path: "addressMasterTreeView",
              name: "Address Master Tree View",
              component: () =>
                import(
                  "@/views/setup/General/AddressMaster/AddressMasterTreeView.vue"
                ),
            },
          ],
        },
        {
          path: "/setup/property-definition",
          name: "Property Definition",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              component: () =>
                import("@/views/setup/General/PropertyDefinition/Index.vue"),
            },
            {
              path: "CreateProperty",
              name: "Create Property",
              component: () =>
                import(
                  "@/views/setup/General/PropertyDefinition/CreateProperty.vue"
                ),
            },
            {
              path: "ViewProperty/:id",
              name: "View Property",
              component: () =>
                import(
                  "@/views/setup/General/PropertyDefinition/ViewProperty.vue"
                ),
            },
            {
              path: "EditProperty/:id",
              name: "Edit Property",
              component: () =>
                import(
                  "@/views/setup/General/PropertyDefinition/EditProperty.vue"
                ),
            },
            {
              path: "CreatePropertyMaster",
              name: "Create Property Master",
              component: () =>
                import(
                  "@/views/setup/General/PropertyDefinition/CreatePropertyMaster.vue"
                ),
            },
            {
              path: "ViewPropertyMaster/:id",
              name: "View Property Master",
              component: () =>
                import(
                  "@/views/setup/General/PropertyDefinition/ViewPropertyMaster.vue"
                ),
            },
            {
              path: "EditPropertyMaster/:id",
              name: "Edit Property Master",
              component: () =>
                import(
                  "@/views/setup/General/PropertyDefinition/EditPropertyMaster.vue"
                ),
            },
          ],
        },
        {
          path: "/setup/closed-user-group",
          name: "Closed User Group",
          component: () =>
            import("@/views/setup/General/ClosedUserGroup/Closed.vue"),
        },
      ],
    },
    {
      path: "/",
      name: "Assets",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "",
          // component: () => import("@/views/setup/Plan/Index"),
        },
        {
          path: "/inventory/supplier",
          name: "Supplier",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              component: () => import("@/views/Inventory/Assets/supplier.vue"),
            },
            {
              path: "createsupplier",
              name: "Create Supplier",
              component: () =>
                import("@/views/Inventory/Assets/CreateSupplier.vue"),
            },
            {
              path: "editsupplier/:id",
              name: "Edit Supplier",
              component: () =>
                import("@/views/Inventory/Assets/EditSupplier.vue"),
            },
            {
              path: "viewsupplier/:id",
              name: "View Supplier",
              component: () =>
                import("@/views/Inventory/Assets/ViewSupplier.vue"),
            },
          ],
        },
        {
          path: "/inventory/items",
          name: "Items",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              component: () =>
                import("@/views/Inventory/Assets/items/items.vue"),
            },
            {
              path: "createitem",
              name: "Create Item",
              component: () =>
                import("@/views/Inventory/Assets/items/CreateItem.vue"),
            },
            {
              path: "edititem/:id",
              name: "Edit Item",
              component: () =>
                import("@/views/Inventory/Assets/items/EditItem.vue"),
            },
            {
              path: "viewitem/:id",
              name: "View Item",
              component: () =>
                import("@/views/Inventory/Assets/items/ViewItem.vue"),
            },
          ],
        },
        {
          path: "/inventory/item-model",
          name: "Item Model",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              component: () =>
                import("@/views/Inventory/Assets/item-model/itemModelList.vue"),
            },
            {
              path: "CreateItemModel",
              name: "Create Item Model",
              component: () =>
                import(
                  "@/views/Inventory/Assets/item-model/CreateItemModel.vue"
                ),
            },
            {
              path: "edititemmodel/:id",
              name: "Edit Item Model",
              component: () =>
                import("@/views/Inventory/Assets/item-model/EditItemModel.vue"),
            },
            {
              path: "viewItemModel/:id",
              name: "View Item Model",
              component: () =>
                import("@/views/Inventory/Assets/item-model/ViewItemModel.vue"),
            },
          ],
        },
      ],
    },
    {
      path: "/setup/plan-validation-rules",
      name: "Plan Validation Rules  ",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "",
          component: () =>
            import("@/views/setup/PlanValidationRules/index.vue"),
        },
        {
          path: "create-validation-rule",
          name: "Create Validation Rule",
          component: () =>
            import(
              "@/views/setup/PlanValidationRules/create_validation_rule.vue"
            ),
        },
        {
          path: "edit-validation-rule/:id",
          name: "Edit Validation Rule",
          component: () =>
            import(
              "@/views/setup/PlanValidationRules/edit_validation_rule.vue"
            ),
        },
        {
          path: "view-validation-rule/:id",
          name: "View Validation Rule",
          component: () =>
            import(
              "@/views/setup/PlanValidationRules/view_validation_rule.vue"
            ),
        },
      ],
    },
    {
      path: "/",
      name: "Ticketing",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "",
          // component: () => import("@/views/setup/Ticketing/Index"),
        },
        {
          path: "/setup/group-ticketing",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              name: "Group Ticketing",
              component: {
                render(c) {
                  return c("router-view");
                },
              },
              children: [
                {
                  path: "",
                  component: () =>
                    import("@/views/setup/Ticketing/group_ticketing/index.vue"),
                },
                {
                  path: "createGroupTicketing",
                  name: "Create Group Ticketing",
                  component: () =>
                    import(
                      "@/views/setup/Ticketing/group_ticketing/create.vue"
                    ),
                },
                {
                  path: "editGroupTicketing/:id",
                  name: "Edit Group Ticketing",
                  component: () =>
                    import("@/views/setup/Ticketing/group_ticketing/edit.vue"),
                },
                {
                  path: "viewGroupTicketing/:id/:categoryId",
                  name: "View Group Ticketing",
                  component: () =>
                    import("@/views/setup/Ticketing/group_ticketing/view.vue"),
                },
              ],
            },
          ],
        },
        {
          path: "/setup/team-mapping",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              name: "Team Mapping",
              component: {
                render(c) {
                  return c("router-view");
                },
              },
              children: [
                {
                  path: "",
                  component: () =>
                    import("@/views/setup/Ticketing/TeamMapping/Index.vue"),
                },
                {
                  path: "createTeamMapping",
                  name: "Create Team Mapping",
                  component: () =>
                    import(
                      "@/views/setup/Ticketing/TeamMapping/createTeamMapping.vue"
                    ),
                },
                {
                  path: "editTeamMapping/:id",
                  name: "Edit Team Mapping",
                  component: () =>
                    import(
                      "@/views/setup/Ticketing/TeamMapping/editTeamMapping.vue"
                    ),
                },
                {
                  path: "viewTeamMapping/:id",
                  name: "View Team Mapping",
                  component: () =>
                    import(
                      "@/views/setup/Ticketing/TeamMapping/viewTeamMapping.vue"
                    ),
                },
              ],
            },
          ],
        },
        {
          path: "/setup/team",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              name: "Team",
              component: {
                render(c) {
                  return c("router-view");
                },
              },
              children: [
                {
                  path: "",
                  component: () =>
                    import("@/views/setup/Ticketing/team-teamuser/Team.vue"),
                },
                {
                  path: "createteam",
                  name: "Create Team",
                  component: () =>
                    import("@/views/setup/Ticketing/team-teamuser/CreateTeam"),
                },
                {
                  path: "editteam/:id",
                  name: "Edit Team",
                  component: () =>
                    import("@/views/setup/Ticketing/team-teamuser/EditTeam"),
                },
                {
                  path: "viewteam/:id",
                  name: "View Team",
                  component: () =>
                    import("@/views/setup/Ticketing/team-teamuser/ViewTeam"),
                },
              ],
            },
          ],
        },
        {
          path: "/setup/team-user",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              name: "Team User",
              component: {
                render(c) {
                  return c("router-view");
                },
              },
              children: [
                {
                  path: "",
                  component: () =>
                    import(
                      "@/views/setup/Ticketing/team-teamuser/TeamUser.vue"
                    ),
                },
                {
                  path: "createticketuser",
                  name: "Create Ticket User",
                  component: () =>
                    import(
                      "@/views/setup/Ticketing/team-teamuser/CreateTicketUsers"
                    ),
                },

                {
                  path: "editicketuser/:id",
                  name: "Edit Team User",
                  component: () =>
                    import(
                      "@/views/setup/Ticketing/team-teamuser/EditTicketUsers"
                    ),
                },
                {
                  path: "viewteamuser/:id",
                  name: "View Team User",
                  component: () =>
                    import(
                      "@/views/setup/Ticketing/team-teamuser/ViewTeamUser"
                    ),
                },
              ],
            },
          ],
        },

        {
          path: "/setup/leave-management",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              name: "Leave Management",
              component: {
                render(c) {
                  return c("router-view");
                },
              },
              children: [
                {
                  path: "",
                  component: () =>
                    import(
                      "@/views/setup/Ticketing/leave_management/index.vue"
                    ),
                },
                {
                  path: "create_leave",
                  name: "Create Leave",
                  component: () =>
                    import(
                      "@/views/setup/Ticketing/leave_management/create.vue"
                    ),
                },

                {
                  path: "edit_leave/:id",
                  name: "Edit Leave",
                  component: () =>
                    import(
                      "@/views/setup/Ticketing/leave_management/edit.vue"
                    ),
                },
                {
                  path: "view_leave/:id",
                  name: "View Leave",
                  component: () =>
                    import(
                      "@/views/setup/Ticketing/leave_management/view.vue"
                    ),
                },
              ],
            },
          ],
        },
        {
          path: "/setup/customer-feedback",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              name: "Customer Feedback",
              component: {
                render(c) {
                  return c("router-view");
                },
              },
              children: [
                {
                  path: "",
                  component: () =>
                    import(
                      "@/views/setup/Ticketing/customer_feedback/index.vue"
                    ),
                },
                {
                  path: "view_customer_feedback/:ticketId/:id",
                  name: "View Customer Feedback",
                  component: () =>
                    import(
                      "@/views/setup/Ticketing/customer_feedback/view.vue"
                    ),
                },
              ],
            },
          ],
        },
        {
          path: "/setup/priority-mapping",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              name: "Sub Category",
              component: {
                render(c) {
                  return c("router-view");
                },
              },
              children: [
                {
                  path: "",
                  component: () =>
                    import("@/views/setup/Ticketing/PriorityMapping/Index.vue"),
                },
                {
                  path: "createPriorityMapping",
                  name: "Create Sub Category",
                  component: () =>
                    import(
                      "@/views/setup/Ticketing/PriorityMapping/createPriorityMapping.vue"
                    ),
                },
                {
                  path: "editPriorityMapping/:id",
                  name: "Edit Sub Category",
                  component: () =>
                    import(
                      "@/views/setup/Ticketing/PriorityMapping/editPriorityMapping.vue"
                    ),
                },
                {
                  path: "viewPriorityMapping/:id",
                  name: "View Sub Category",
                  component: () =>
                    import(
                      "@/views/setup/Ticketing/PriorityMapping/viewPriorityMapping.vue"
                    ),
                },
              ],
            },
          ],
        },
      ],
    },
    {
      path: "/",
      name: "Subscription Master",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "",
          component: () => import("@/views/setup/Subscription/Index"),
        },
        {
          path: "/setup/charge-code",
          name: "Charge Code",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              component: () =>
                import("@/views/setup/Subscription/ChargeCode/ChargeCode.vue"),
            },
            {
              path: "create-charge-code",
              name: "Create Charge Code",
              component: () =>
                import(
                  "@/views/setup/Subscription/ChargeCode/CreateChargeCode"
                ),
            },
            {
              path: "edit-charge-code/:id",
              name: "Edit Charge Code",
              component: () =>
                import("@/views/setup/Subscription/ChargeCode/EditChargeCode"),
            },
            {
              path: "chargeCode/:id",
              name: "View Charge Code",
              component: () =>
                import("@/views/setup/Subscription/ChargeCode/ViewChargeCode"),
            },
          ],
        },
        {
          path: "/setup/contract-period",
          name: "Contract Period",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              component: () =>
                import("@/views/setup/Subscription/ContractPeriod/Index.vue"),
            },
            {
              path: "createContract",
              name: "Create Contract",
              component: () =>
                import(
                  "@/views/setup/Subscription/ContractPeriod/CreateContract.vue"
                ),
            },
            {
              path: "editcontract/:id",
              name: "Edit Contract",
              component: () =>
                import(
                  "@/views/setup/Subscription/ContractPeriod/EditContract.vue"
                ),
            },
            {
              path: "viewcontract/:id",
              name: "View Contract",
              component: () =>
                import(
                  "@/views/setup/Subscription/ContractPeriod/ViewContract.vue"
                ),
            },
          ],
        },
        {
          path: "/setup/fee-master",
          name: "Fee Master",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              component: () =>
                import(
                  "@/views/setup/Subscription/FeeMaster/feemasterList.vue"
                ),
            },
            {
              path: "create_fee_master",
              name: "Create Fee Master",
              component: () =>
                import(
                  "@/views/setup/Subscription/FeeMaster/CreateFeemaster.vue"
                ),
            },
            {
              path: "edit_fee_master/:id",
              name: "Edit Fee Master",
              component: () =>
                import(
                  "@/views/setup/Subscription/FeeMaster/EditFeemaster.vue"
                ),
            },
            {
              path: "view_fee/:id",
              name: "View Fee",
              component: () =>
                import(
                  "@/views/setup/Subscription/FeeMaster/Viewfeemaster.vue"
                ),
            },
          ],
        },
        {
          path: "/setup/tax",
          name: "Tax Master",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              component: () =>
                import("@/views/setup/Subscription/Tax/TaxList.vue"),
            },
            {
              path: "create-tax",
              name: "Create Tax",
              component: () =>
                import("@/views/setup/Subscription/Tax/CreateTax"),
            },
            {
              path: "edit-tax/:taxId",
              name: "Edit Tax",
              component: () => import("@/views/setup/Subscription/Tax/EditTax"),
            },
          ],
        },
      ],
    },
    {
      path: "/",
      name: "Plan Management",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "",
          // component: () =>
          //   import("@/views/setup/Discount/discount/discount.vue"),
        },
        {
          path: "/setup/discount",
          name: "Discount",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              component: () =>
                import("@/views/setup/Discount/discount/discount.vue"),
            },
            {
              path: "create-discount",
              name: "Create Discount",
              component: () =>
                import("@/views/setup/Discount/discount/createDiscount.vue"),
            },
            {
              path: "view/:id",
              name: "Discount Detail",
              component: () =>
                import("@/views/setup/Discount/discount/discountDetail.vue"),
            },
          ],
        },
        {
          path: "/setup/discount-promotion",
          name: "Promotion",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              component: () =>
                import(
                  "@/views/setup/Discount/DiscountandPromotion/DiscountandPromotion.vue"
                ),
            },
            {
              path: "view/:id",
              name: "Promotion Detail",
              component: () =>
                import(
                  "@/views/setup/Discount/DiscountandPromotion/discountPromotionDetails.vue"
                ),
            },
            {
              path: "createPromotion",
              name: "Create Promotion",
              component: () =>
                import(
                  "@/views/setup/Discount/DiscountandPromotion/createPromotion"
                ),
            },
          ],
        },
        {
          path: "/setup/plan-pricing",
          name: "Plan Pricing",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              component: () =>
                import("@/views/setup/PlanPricing/PlansList.vue"),
            },
            {
              path: "createplans",
              name: "Create Plan",
              component: () => import("@/views/setup/PlanPricing/index.vue"),
            },
            {
              path: "editplans/:id",
              name: "Edit Plan",
              component: () => import("@/views/setup/PlanPricing/EditPlan"),
            },
            {
              path: "viewplan/:id",
              name: "View Plan",
              component: () => import("@/views/setup/PlanPricing/ViewPlan"),
            },
            {
              path: "contentplan/:id",
              name: "Plan Content",
              component: () => import("@/views/setup/PlanPricing/PlanContent"),
            },
            {
              path: "discount/:id",
              name: "Add Discount",
              component: () => import("@/views/setup/PlanPricing/AddDiscount"),
            },
            {
              path: "pricing/:id",
              name: "Pricing",
              component: () => import("@/views/setup/PlanPricing/Pricing"),
            },
            {
              path: "view-price/:id",
              name: "View Price",
              component: () => import("@/views/setup/PlanPricing/ViewPrice"),
            },
          ],
        },
      ],
    },
    {
      path: "/",
      name: "Plan Pre-Reqisites",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "",
          // component: () => import("@/views/setup/Plan/Index"),
        },
        {
          path: "/setup/price-region",
          name: "Price Region",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              component: () =>
                import("@/views/setup/Plan/PriceRegion/PriceRegion.vue"),
            },
            {
              path: "ViewPriceRegion/:id",
              name: "View Price Region",
              component: () =>
                import("@/views/setup/Plan/PriceRegion/ViewPriceRegion.vue"),
            },
            {
              path: "editPriceRegion/:id",
              name: "Edit Price Region",
              component: () =>
                import("@/views/setup/Plan/PriceRegion/editPriceRegion.vue"),
            },
            {
              path: "createPriceRegion",
              name: "Create Price Region",
              component: () =>
                import("@/views/setup/Plan/PriceRegion/createPriceRegion"),
            },
          ],
        },
        {
          path: "/setup/service-products/services",
          name: "Services",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              component: () =>
                import("@/views/setup/Plan/ServicesAndProducts/Services.vue"),
            },
            {
              path: "CreateService",
              name: "Create Service",
              component: () =>
                import("@/views/setup/Plan/ServicesAndProducts/CreateService"),
            },
            {
              path: "/editservice/:id",
              name: "Edit Service",
              component: () =>
                import("@/views/setup/Plan/ServicesAndProducts/EditService"),
            },
            {
              path: "/ViewServices/:id",
              name: "View Services",
              component: () =>
                import(
                  "@/views/setup/Plan/ServicesAndProducts/ViewServices.vue"
                ),
            },
          ],
        },
        {
          path: "/setup/service-products/products",
          name: "Products",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              component: () =>
                import("@/views/setup/Plan/ServicesAndProducts/Products.vue"),
            },
            {
              path: "CreateProduct",
              name: "Create Product",
              component: () =>
                import("@/views/setup/Plan/ServicesAndProducts/CreateProduct"),
            },
            {
              path: "/editproduct/:id",
              name: "Edit Product",
              component: () =>
                import("@/views/setup/Plan/ServicesAndProducts/EditProducts"),
            },
            {
              path: "/ViewProducts/:id",
              name: "View Products",
              component: () =>
                import(
                  "@/views/setup/Plan/ServicesAndProducts/ViewProducts.vue"
                ),
            },
          ],
        },
        {
          path: "/setup/cataloge-mapping/sales",
          name: "Sales Catalogue",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              component: () =>
                import("@/views/setup/Plan/CatalogeMapping/salesCatalogue.vue"),
            },
            {
              path: "viewSalesCataloge/:id",
              name: "View Sales Cataloge",
              component: () =>
                import(
                  "@/views/setup/Plan/CatalogeMapping/viewSalesCataloge.vue"
                ),
            },
            {
              path: "editSalesCataloge/:id",
              name: "Edit Sales Cataloge",
              component: () =>
                import(
                  "@/views/setup/Plan/CatalogeMapping/editSalesCataloge.vue"
                ),
            },
            {
              path: "assignUsersCataloge/:id",
              name: "Assign Users Catalogue",
              component: () =>
                import(
                  "@/views/setup/Plan/CatalogeMapping/assignUsersCatalogue.vue"
                ),
            },
            {
              path: "createSalesCataloge",
              name: "Create Sales Cataloge",
              component: () =>
                import(
                  "@/views/setup/Plan/CatalogeMapping/createSalesCataloge.vue"
                ),
            },
          ],
        },
        {
          path: "/setup/cataloge-mapping/user",
          name: "User Catalogue",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              component: () =>
                import("@/views/setup/Plan/CatalogeMapping/userCatalogue.vue"),
            },
            {
              path: "viewUserCataloge/:id",
              name: "View User Cataloge",
              component: () =>
                import(
                  "@/views/setup/Plan/CatalogeMapping/viewUserCataloge.vue"
                ),
            },
            {
              path: "editUserCataloge/:id",
              name: "Edit User Cataloge",
              component: () =>
                import(
                  "@/views/setup/Plan/CatalogeMapping/editUserCataloge.vue"
                ),
            },
            {
              path: "createUserCataloge",
              name: "Create User Cataloge",
              component: () =>
                import(
                  "@/views/setup/Plan/CatalogeMapping/createUserCataloge.vue"
                ),
            },
          ],
        },
        {
          path: "/setup/broadcaster-channel",
          name: "Sub Products",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              component: () =>
                import(
                  "@/views/setup/Plan/BroadcasterChannelMapping/broadcasterChannelMappingList.vue"
                ),
            },
            {
              path: "createbroadcaster",
              name: "Create Broadcaster",
              component: () =>
                import(
                  "@/views/setup/Plan/BroadcasterChannelMapping/CreateBroadcaster"
                ),
            },
            {
              path: "editbroadcaster/:id",
              name: "Edit Broadcaster",
              component: () =>
                import(
                  "@/views/setup/Plan/BroadcasterChannelMapping/EditBroadcaster"
                ),
            },
            {
              path: "viewBroadcaster/:id",
              name: "View Broadcaster",
              component: () =>
                import(
                  "@/views/setup/Plan/BroadcasterChannelMapping/viewBroadcaster"
                ),
            },
            {
              path: "createchannel",
              name: "Create Channel",
              component: () =>
                import(
                  "@/views/setup/Plan/BroadcasterChannelMapping/CreateChannel"
                ),
            },
            {
              path: "channelView/:id",
              name: "Channel View",
              component: () =>
                import(
                  "@/views/setup/Plan/BroadcasterChannelMapping/channelView"
                ),
            },
            {
              path: "editchannel/:id",
              name: "Edit Channel",
              component: () =>
                import(
                  "@/views/setup/Plan/BroadcasterChannelMapping/EditChannel"
                ),
            },
            {
              path: "createproductmapping",
              name: "Create Product Mapping",
              component: () =>
                import(
                  "@/views/setup/Plan/BroadcasterChannelMapping/CreateProductMapping"
                ),
            },
            {
              path: "editproductmapping/:id",
              name: "Edit Product Mapping",
              component: () =>
                import(
                  "@/views/setup/Plan/BroadcasterChannelMapping/EditProductMapping"
                ),
            },
            {
              path: "viewProductMapping/:id",
              name: "View Product Mapping",
              component: () =>
                import(
                  "@/views/setup/Plan/BroadcasterChannelMapping/viewProductMapping"
                ),
            },
          ],
        },
      ],
    },
    {
      path: "/",
      name: "Usage Rating",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "",
          component: () =>
            import("@/views/setup/UsageRating/UsageRatingUOMList.vue"),
        },
        {
          path: "/setup/usage-rating/template",
          name: "Usage Template",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              component: () => import("@/views/setup/UsageRating/template.vue"),
            },
            {
              path: "ViewTemplate/:id",
              name: "View Template",
              component: () =>
                import("@/views/setup/UsageRating/ViewTemplate.vue"),
            },
            {
              path: "CreateTemplate",
              name: "Create Template",
              component: () =>
                import("@/views/setup/UsageRating/CreateTemplate.vue"),
            },
            {
              path: "EditTemplate/:id",
              name: "Edit Template",
              component: () =>
                import("@/views/setup/UsageRating/EditTemplate.vue"),
            },
          ],
        },
        {
          path: "/setup/usage-rating/uom",
          name: "UOM",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              component: () => import("@/views/setup/UsageRating/uom.vue"),
            },
            {
              path: "View_UOM/:id",
              name: "View UOM",
              component: () => import("@/views/setup/UsageRating/View_UOM.vue"),
            },
            {
              path: "create_UOM",
              name: "Create UOM",
              component: () =>
                import("@/views/setup/UsageRating/create_UOM.vue"),
            },
            {
              path: "edit_UOM/:id",
              name: "Edit UOM",
              component: () => import("@/views/setup/UsageRating/edit_UOM.vue"),
            },
          ],
        },
        {
          path: "/setup/usage-rating/rum",
          name: "RUM",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              component: () => import("@/views/setup/UsageRating/rum.vue"),
            },
            {
              path: "View_RUM/:id",
              name: "View RUM",
              component: () => import("@/views/setup/UsageRating/View_RUM.vue"),
            },
            {
              path: "create_RUM",
              name: "Create RUM",
              component: () =>
                import("@/views/setup/UsageRating/create_RUM.vue"),
            },
            {
              path: "EditRum/:id",
              name: "Edit RUM",
              component: () => import("@/views/setup/UsageRating/EditRum.vue"),
            },
          ],
        },
        {
          path: "/setup/usage-rating/time",
          name: "Time Period",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              component: () =>
                import("@/views/setup/UsageRating/timePeriod.vue"),
            },
            {
              path: "CreateTimeModel",
              name: "Create Time Model",
              component: () =>
                import("@/views/setup/UsageRating/CreateTimeModel.vue"),
            },
            {
              path: "TimeModelTree",
              name: "Time Model Tree",
              component: () =>
                import("@/views/setup/UsageRating/TimeModelTree.vue"),
            },
          ],
        },
        {
          path: "/setup/usage-rating/rateplan",
          name: "Rate Plan",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              component: () => import("@/views/setup/UsageRating/ratePlan.vue"),
            },
            {
              path: "CreateUsageRating",
              name: "Create Usage Rating",
              component: () =>
                import("@/views/setup/UsageRating/CreateUsageRating.vue"),
            },
            {
              path: "CreateUsageRating/:id",
              name: "Create Rate Plan",
              component: () =>
                import("@/views/setup/UsageRating/createRatePlan.vue"),
            },
            {
              path: "viewUsagerating/:id",
              name: "View Usage Rating",
              component: () =>
                import("@/views/setup/UsageRating/viewUsagerating.vue"),
            },
            {
              path: "viewUsagerating/:id/usage-rate",
              name: "Usage Rate",
              component: () =>
                import("@/views/setup/UsageRating/usageRate.vue"),
            },
          ],
        },

        //UsageRating
        {
          path: "UsageRating",
          name: "Usage Rating",
          component: () =>
            import("@/views/setup/UsageRating/RatingTemplate.vue"),
        },
      ],
    },
    {
      path: "/",
      name: "Zone Setup",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "",
          component: () => import("@/views/setup/ZoneSetup/zone.vue"),
        },
        {
          path: "/setup/zone-setup/number",
          name: "Number Zone",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              component: () => import("@/views/setup/ZoneSetup/number.vue"),
            },
            {
              path: "createNumberZone",
              name: "Create Number Zone",
              component: () =>
                import("@/views/setup/ZoneSetup/CreateNumberZone.vue"),
            },
            {
              path: "EditNumberZone/:id",
              name: "Edit Number Zone",
              component: () =>
                import("@/views/setup/ZoneSetup/EditNumberZone.vue"),
            },
            {
              path: "ViewNumberZone/:id",
              name: "View Number Zone",
              component: () =>
                import("@/views/setup/ZoneSetup/ViewNumberZone.vue"),
            },
          ],
        },
        {
          path: "/setup/zone-setup/apn",
          name: "APN Zone",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              component: () => import("@/views/setup/ZoneSetup/apn.vue"),
            },
            {
              path: "createApnZone",
              name: "Create APN Zone",
              component: () =>
                import("@/views/setup/ZoneSetup/CreateApnZone.vue"),
            },
            {
              path: "EditApnZone/:id",
              name: "Edit APN Zone",
              component: () =>
                import("@/views/setup/ZoneSetup/EditApnZone.vue"),
            },
            {
              path: "ViewApnZone/:id",
              name: "View APN Zone",
              component: () =>
                import("@/views/setup/ZoneSetup/ViewApnZone.vue"),
            },
          ],
        },
        {
          path: "/setup/zone-setup/operator",
          name: "Operator Zone",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              component: () => import("@/views/setup/ZoneSetup/operator.vue"),
            },
            {
              path: "create_operator_zone",
              name: "Create Operator Zone",
              component: () =>
                import("@/views/setup/ZoneSetup/create_operator_zone.vue"),
            },
            {
              path: "EditOperatorZone/:id",
              name: "Edit Operator Zone",
              component: () =>
                import("@/views/setup/ZoneSetup/EditOperatorZone.vue"),
            },
            {
              path: "ViewOperatorZone/:id",
              name: "View Operator Zone",
              component: () =>
                import("@/views/setup/ZoneSetup/ViewOperatorZone.vue"),
            },
          ],
        },
        {
          path: "/setup/zone-setup/ic",
          name: "IC Zone",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              component: () => import("@/views/setup/ZoneSetup/ic.vue"),
            },
            {
              path: "create_ic_zone",
              name: "Create IC Zone",
              component: () =>
                import("@/views/setup/ZoneSetup/create_ic_zone.vue"),
            },
            {
              path: "EditIcZone/:id",
              name: "Edit IC Zone",
              component: () => import("@/views/setup/ZoneSetup/EditIcZone.vue"),
            },
            {
              path: "ViewIcZone/:id",
              name: "View IC Zone",
              component: () => import("@/views/setup/ZoneSetup/ViewIcZone.vue"),
            },
          ],
        },
      ],
    },
    {
      path: "/",
      name: "Media Pricing",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "",
          component: () => import("@/views/setup/MediaPricing/Index.vue"),
        },
        {
          path: "/setup/media-pricing/details",
          name: "Media Details",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              component: () =>
                import("@/views/setup/MediaPricing/mediaDetails.vue"),
            },
            {
              path: "create_Media",
              name: "Create Media",
              component: () =>
                import("@/views/setup/MediaPricing/create_Media.vue"),
            },
            {
              path: "view_Media/:id",
              name: "View Media",
              component: () =>
                import("@/views/setup/MediaPricing/view_Media.vue"),
            },
            {
              path: "add_Media",
              name: "Add Media",
              component: () =>
                import("@/views/setup/MediaPricing/add_Media.vue"),
            },
            {
              path: "edit_Media/:id",
              name: "Edit Media",
              component: () =>
                import("@/views/setup/MediaPricing/edit_Media.vue"),
            },
          ],
        },
        {
          path: "/setup/media-pricing/event",
          name: "Media Event",
          component: {
            render(c) {
              return c("router-view");
            },
          },
          children: [
            {
              path: "",
              component: () => import("@/views/setup/MediaPricing/event.vue"),
            },
            {
              path: "add_Price/:id",
              name: "Add Price",
              component: () =>
                import("@/views/setup/MediaPricing/add_Price.vue"),
            },

            {
              path: "create_event",
              name: "Create Event",
              component: () =>
                import("@/views/setup/MediaPricing/CreateEvent.vue"),
            },
            {
              path: "edit_event/:id",
              name: "Edit Event",
              component: () =>
                import("@/views/setup/MediaPricing/edit_Event.vue"),
            },
            {
              path: "view_event/:id",
              name: "View Event",
              component: () =>
                import("@/views/setup/MediaPricing/view_Event.vue"),
            },
          ],
        },
      ],
    },
    {
      path: "/setup/collection-profile",
      name: "Collection Profile",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "",
          component: () => import("@/views/setup/CollectionProfile/Index.vue"),
        },
        {
          path: "createCollectionProfile",
          name: "Create Collection Profile",
          component: () =>
            import(
              "@/views/setup/CollectionProfile/createCollectionProfile.vue"
            ),
        },
        {
          path: "editCollectionProfile/:id",
          name: "Edit Collection Profile",
          component: () =>
            import("@/views/setup/CollectionProfile/editCollectionProfile.vue"),
        },
        {
          path: "collection/:id",
          name: "Collection Detail",
          component: () =>
            import("@/views/setup/CollectionProfile/collectionDetail.vue"),
        },
      ],
    },
    {
      path: "/setup/automation-master",
      name: "Automation Master",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      children: [
        {
          path: "",
          component: () => import("@/views/setup/AutomationMaster/index.vue"),
        },
        {
          path: "create-automation",
          name: "Create Automation",
          component: () =>
            import(
              "@/views/setup/AutomationMaster/create.vue"
            ),
        },
        {
          path: "edit-automation/:id",
          name: "Edit Automation",
          component: () =>
            import("@/views/setup/AutomationMaster/edit.vue"),
        },
        {
          path: "automation-detail/:id",
          name: "Automation Detail",
          component: () =>
            import("@/views/setup/AutomationMaster/automationDetail.vue"),
        },
      ],
    },

    // {
    //   path: "/chargeCode",
    //   name: "Charge Code",
    //   component: () =>
    //     import("@/views/setup/Subscription/ChargeCode/ChargeCode"),
    //   children: [],
    // },
  ],
};
